import moment from 'moment';
import { Category, Device } from './types';

export enum UrlEnum {
  publicCategories = '/api/public/categories',
  publicDevices = '/api/public/devices',
  publicDeviceRepairs = '/api/public/deviceRepairs',
  publicRepairOrders = '/api/public/repairOrders',
  localities = '/api/fanCourier/localities',
  cities = '/api/fanCourier/cities',
  streets = '/api/fanCourier/streets',
}

export function validateEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function validatePhone(phone: string): boolean {
  return /^\d{10}$/.test(phone.replace(/\s/g, ''));
}

export function validatePickupDate(date: string): boolean {
  return moment(date).isAfter(moment());
}

export function slugify(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function getCategorySlug(category: Category): string {
  return slugify(category.name);
}

export function findCategoryBySlug(categories: Category[], slug: string): Category | null {
  return categories.find((c) => getCategorySlug(c) === slug) || null;
}

/**
 * A handful of devices in the catalog share an identical (or
 * near-identical) name within the same category, so the plain slug alone
 * isn't always unique — a short id suffix is appended only for the
 * colliding devices, keeping the common case's URL clean.
 */
export function getDeviceSlug(device: Device, devicesInSameCategory: Device[]): string {
  const baseSlug = slugify(device.deviceName);
  const collidingSiblings = devicesInSameCategory.filter(
    (d) => slugify(d.deviceName) === baseSlug
  );
  if (collidingSiblings.length <= 1) return baseSlug;
  return `${baseSlug}-${device._id.slice(-6)}`;
}

export function findDeviceBySlug(devices: Device[], categoryId: string, slug: string): Device | null {
  const devicesInCategory = devices.filter((d) => d.category === categoryId);
  return (
    devicesInCategory.find((d) => getDeviceSlug(d, devicesInCategory) === slug) || null
  );
}
